// src/pages/Plans.jsx
import React, { useState, useEffect, useRef } from "react";
import "./plan.css";
import "./plan-payment.css";
import { plans } from '../components/layout/data';
import Carousel from 'react-bootstrap/Carousel';
import image4 from '../assets/image12.jpg';
import image5 from '../assets/image13.jpg';
import image6 from '../assets/image14.jpg';
import image7 from '../assets/image15.jpg';
import image8 from '../assets/image16.jpg';
import image9 from '../assets/images5.jpeg';
import image10 from '../assets/images6.jpeg';
import Footer from "./Footer";
import Header from "../components/layout/Header";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import TestimonialSlider from './TestimonialSlider';
import { useNavigate } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_API_URL?.replace(/\/api$/, "") || "https://suvidha-backend-353j.onrender.com";

function authHeaders() {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

// ── Load Razorpay script ──────────────────────────────────
function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload  = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

// Plan IDs are loaded from backend — no hardcoding needed

// ── Success Modal ─────────────────────────────────────────
function SuccessModal({ plan, endDate, onClose }) {
  return (
    <div className="pp-overlay" onClick={onClose}>
      <div className="pp-modal pp-success" onClick={e => e.stopPropagation()}>
        <div className="pp-success-icon">🎉</div>
        <h2>Subscription Activated!</h2>
        <p className="pp-success-plan">{plan}</p>
        <p className="pp-success-desc">
          Your plan is now <strong>active</strong> and you have full access to all included services.
          No waiting — it's ready right now!
        </p>
        <div className="pp-success-until">
          <span>✅ Active until</span>
          <strong>{new Date(endDate).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</strong>
        </div>
        <button className="pp-btn-primary" onClick={onClose}>
          Continue →
        </button>
      </div>
    </div>
  );
}

// ── Confirm Modal — shows before payment ────────────────
function ConfirmModal({ plan, billing, price, onConfirm, onClose, loading }) {
  return (
    <div className="pp-overlay" onClick={onClose}>
      <div className="pp-modal" onClick={e => e.stopPropagation()}>
        <button className="pp-close" onClick={onClose}>✕</button>
        <div className="pp-modal-icon">🔐</div>
        <h2>Confirm Subscription</h2>

        <div className="pp-confirm-details">
          <div className="pp-confirm-row">
            <span>Plan</span>
            <strong>{plan}</strong>
          </div>
          <div className="pp-confirm-row">
            <span>Billing</span>
            <strong>{billing === "monthly" ? "Monthly" : billing === "quarterly" ? "Quarterly" : "Yearly"}</strong>
          </div>
          <div className="pp-confirm-row pp-confirm-total">
            <span>Total</span>
            <strong>₹{Number(price).toLocaleString("en-IN")}</strong>
          </div>
        </div>

        <div className="pp-instant-note">
          ⚡ <strong>Instant activation</strong> — No waiting, no admin approval needed.
          Your plan activates the moment payment is successful.
        </div>

        <button className="pp-btn-primary" onClick={onConfirm} disabled={loading}>
          {loading ? (
            <><span className="pp-spinner" /> Processing...</>
          ) : (
            <>Pay ₹{Number(price).toLocaleString("en-IN")} →</>
          )}
        </button>
        <button className="pp-btn-ghost" onClick={onClose} disabled={loading}>
          Cancel
        </button>
      </div>
    </div>
  );
}


// ── Premium Benefits (replaces broken Carousel) ──────────
const BENEFITS = [
  { icon:"🚨", title:"24/7 Emergency Coordination",     desc:"Round-the-clock support for elders in medical or personal emergencies." },
  { icon:"📱", title:"Suvidha App — Real-Time Updates",  desc:"Real-time updates on your parents' health and safety at your fingertips." },
  { icon:"🧪", title:"Annual Lab Tests",                 desc:"81 vital health parameters tracked annually for complete well-being." },
  { icon:"👨‍⚕️", title:"Doctor-on-Call (4× a year)",    desc:"Connect with a doctor during emergencies for quick medical advice." },
  { icon:"🏠", title:"Home Visits by Professionals",     desc:"Trained nurses and attendants visit your home as per your plan." },
  { icon:"💊", title:"Medication Management",            desc:"Timely reminders and professional oversight of daily medications." },
  { icon:"📋", title:"Personalised Care Plans",          desc:"Custom geriatric care plans designed around your loved one's needs." },
  { icon:"🛡️", title:"Fall Risk Assessments",           desc:"Regular assessments to prevent falls and ensure home safety." },
];

function PremiumBenefits({ images }) {
  const [current, setCurrent] = useState(0);
  const total = BENEFITS.length;

  // Auto-slide every 3.5s
  useEffect(() => {
    const t = setInterval(() => setCurrent(c => (c+1) % total), 3500);
    return () => clearInterval(t);
  }, [total]);

  const prev = () => setCurrent(c => (c - 1 + total) % total);
  const next = () => setCurrent(c => (c + 1) % total);

  // Show 4 on desktop, 2 on tablet, 1 on mobile — handled via CSS grid
  const BG_COLORS = ["#EEF4FB","#FFF6ED","#F3FBF4","#EEF4FB","#FFF6ED","#F3FBF4","#EEF4FB","#FFF6ED"];
  const IC_COLORS = ["#1F4E8C","#F39C12","#4CAF50","#1F4E8C","#F39C12","#4CAF50","#1F4E8C","#F39C12"];

  return (
    <div style={{
      background:"var(--subtle-neutral,#E2E8F0)",
      padding:"clamp(40px,6vw,72px) clamp(16px,5vw,60px)"
    }}>
      {/* Heading */}
      <div style={{ textAlign:"center", marginBottom:36 }}>
        <div style={{ fontSize:12, fontWeight:800, color:"var(--base-primary,#1F4E8C)",
          textTransform:"uppercase", letterSpacing:".6px", marginBottom:8 }}>
          Why Choose Suvidha
        </div>
        <h2 style={{
          fontFamily:"inherit", fontSize:"clamp(22px,4vw,34px)",
          fontWeight:800, color:"var(--heading-primary,#0F2A4A)", margin:"0 0 10px"
        }}>Premium Benefits for Your Loved Ones</h2>
        <p style={{ color:"var(--base-neutral,#64748b)", fontSize:15, maxWidth:520, margin:"0 auto" }}>
          Every plan comes with these essential care features to give you peace of mind.
        </p>
      </div>

      {/* Desktop grid — 4 across */}
      <div className="pb-grid">
        {BENEFITS.map((b, i) => (
          <div key={i} className="pb-card" style={{ background: BG_COLORS[i] }}>
            <div style={{
              width:52, height:52, borderRadius:14, marginBottom:16,
              background:"var(--base-white,#fff)",
              display:"flex", alignItems:"center", justifyContent:"center",
              fontSize:26, boxShadow:"0 2px 8px rgba(0,0,0,.08)"
            }}>{b.icon}</div>
            <h5 style={{
              fontSize:15, fontWeight:800,
              color: IC_COLORS[i], margin:"0 0 8px", lineHeight:1.3
            }}>{b.title}</h5>
            <p style={{ fontSize:13, color:"var(--base-neutral,#64748b)", lineHeight:1.6, margin:0 }}>{b.desc}</p>
          </div>
        ))}
      </div>

      {/* Mobile slider — 1 card at a time */}
      <div className="pb-slider">
        <div style={{
          background: BG_COLORS[current],
          borderRadius:20, padding:"28px 24px",
          minHeight:220, textAlign:"center",
          boxShadow:"0 4px 20px rgba(0,0,0,.08)",
          transition:"all .3s ease"
        }}>
          <div style={{
            width:60, height:60, borderRadius:16, margin:"0 auto 16px",
            background:"var(--base-white,#fff)",
            display:"flex", alignItems:"center", justifyContent:"center",
            fontSize:30, boxShadow:"0 2px 8px rgba(0,0,0,.08)"
          }}>{BENEFITS[current].icon}</div>
          <h5 style={{
            fontSize:18, fontWeight:800,
            color: IC_COLORS[current], margin:"0 0 10px"
          }}>{BENEFITS[current].title}</h5>
          <p style={{ fontSize:14, color:"var(--base-neutral,#64748b)", lineHeight:1.6, margin:0 }}>
            {BENEFITS[current].desc}
          </p>
        </div>
        {/* Dots + arrows */}
        <div style={{ display:"flex", justifyContent:"center", alignItems:"center", gap:12, marginTop:20 }}>
          <button onClick={prev} style={{
            width:36, height:36, borderRadius:"50%", border:"1.5px solid #CBD5E1",
            background:"#fff", cursor:"pointer", fontSize:18, color:"#64748B",
            display:"flex", alignItems:"center", justifyContent:"center"
          }}>‹</button>
          <div style={{ display:"flex", gap:6 }}>
            {BENEFITS.map((_,i) => (
              <div key={i} onClick={() => setCurrent(i)} style={{
                width: i===current ? 22 : 8, height:8, borderRadius:999,
                background: i===current ? "var(--base-primary,#1F4E8C)" : "#CBD5E1",
                cursor:"pointer", transition:"all .3s"
              }}/>
            ))}
          </div>
          <button onClick={next} style={{
            width:36, height:36, borderRadius:"50%", border:"1.5px solid #CBD5E1",
            background:"#fff", cursor:"pointer", fontSize:18, color:"#64748B",
            display:"flex", alignItems:"center", justifyContent:"center"
          }}>›</button>
        </div>
        {/* Counter */}
        <div style={{ textAlign:"center", fontSize:12, color:"#94A3B8", marginTop:6, fontWeight:600 }}>
          {current+1} / {total}
        </div>
      </div>

      {/* Download button */}
      <div style={{ textAlign:"center", marginTop:36 }}>
        <button style={{
          background:"var(--base-primary,#1F4E8C)", color:"#fff",
          border:"none", padding:"14px 40px", borderRadius:30,
          fontSize:15, fontWeight:700, cursor:"pointer",
          fontFamily:"inherit",
          boxShadow:"0 4px 16px rgba(31,78,140,.3)"
        }}>Download Brochure</button>
      </div>

      <style>{`
        .pb-grid   { display: grid; grid-template-columns: repeat(4,1fr); gap: 16px; }
        .pb-card   { border-radius: 18px; padding: 24px 20px; transition: transform .2s; }
        .pb-card:hover { transform: translateY(-4px); }
        .pb-slider { display: none; }
        @media (max-width: 900px) {
          .pb-grid { grid-template-columns: repeat(2,1fr); }
        }
        @media (max-width: 560px) {
          .pb-grid   { display: none; }
          .pb-slider { display: block; }
        }
      `}</style>
    </div>
  );
}

// ── Tab label helper ─────────────────────────────────────
const TAB_LABELS = {
  care:     "Care Add-ons",
  diabetes: "Diabetes Management",
  dementia: "Dementia Management",
  kidney:   "Kidney Disease",
  stroke:   "Stroke Management",
};

const TAB_ICONS = {
  care:     "🏥",
  diabetes: "🩸",
  dementia: "🧠",
  kidney:   "💊",
  stroke:   "❤️‍🩹",
};

const BRAND   = "#1F4E8C";   // brand primary blue — used everywhere

const ADDON_PLANS = [
  { key:"care",     title:"Care Management Plan",     price:"₹1,599", color:BRAND,
    items:["Weekly wellness check-in call","One doctor tele-consult in 3 months","Easy access to professional medical advice","Doctor home visit once in 6 months","Personalised geriatric care plan","Regular health & fall risk assessments","Annual full body checkup","Priority access to nurses & attendants"] },
  { key:"diabetes", title:"Diabetes Management Plan", price:"₹1,499", color:BRAND,
    items:["Weekly blood sugar monitoring support","Diet and lifestyle guidance for diabetes","Doctor tele-consultation once every 2 months","Medication reminder support","Quarterly diabetes health assessment","Lab test coordination for sugar monitoring","Emergency medical consultation access","Personalized diabetes care plan"] },
  { key:"dementia", title:"Dementia Management Plan", price:"₹1,699", color:BRAND,
    items:["Weekly cognitive wellness check-in","Caregiver guidance and support","Doctor tele-consultation every 2 months","Memory and cognitive health tracking","Emergency assistance coordination","Medication monitoring support","Quarterly home safety assessment","Personalized dementia care planning"] },
  { key:"kidney",   title:"Kidney Management Plan",   price:"₹1,799", color:BRAND,
    items:["Weekly health monitoring calls","Doctor tele-consultation once every 2 months","Diet and lifestyle guidance for kidney health","Lab test coordination for kidney function","Medication management support","Quarterly health assessment","Emergency medical assistance","Personalized kidney care plan"] },
  { key:"stroke",   title:"Stroke Management Plan",   price:"₹1,599", color:BRAND,
    items:["Weekly recovery monitoring calls","Doctor tele-consultation every 2 months","Physiotherapy coordination support","Medication and recovery tracking","Caregiver guidance for stroke recovery","Emergency medical support","Quarterly rehabilitation assessment","Personalized stroke recovery plan"] },
];

// ── Callback Popup ────────────────────────────────────────
function CallbackPopup({ plan, onClose }) {
  const [form, setForm]   = useState({ name:"", phone:"", time:"" });
  const [done, setDone]   = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) return;
    setLoading(true);
    setTimeout(() => { setLoading(false); setDone(true); }, 1000);
  };

  return (
    <>
      <div onClick={onClose} style={{ position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:9999,backdropFilter:"blur(4px)" }}/>
      <div onClick={e=>e.stopPropagation()} style={{
        position:"fixed", top:"50%", left:"50%", transform:"translate(-50%,-50%)",
        background:"#fff", borderRadius:22, padding:"28px 24px",
        width:"calc(100% - 32px)", maxWidth:440, zIndex:10000,
        boxShadow:"0 24px 60px rgba(0,0,0,.22)", fontFamily:"inherit"
      }}>
        <button onClick={onClose} style={{
          position:"absolute", top:14, right:14, width:32, height:32,
          borderRadius:"50%", background:"#F1F5F9", border:"none",
          cursor:"pointer", fontSize:15, color:"#64748B"
        }}>✕</button>

        {done ? (
          <div style={{ textAlign:"center", padding:"12px 0" }}>
            <div style={{ fontSize:48, marginBottom:12 }}>📞</div>
            <h3 style={{ fontWeight:800, fontSize:20, color:"#1E293B", margin:"0 0 8px" }}>Request Received!</h3>
            <p style={{ color:"#64748B", fontSize:14, lineHeight:1.6, margin:"0 0 20px" }}>
              Thank you <strong>{form.name}</strong>! Our team will call you on <strong>{form.phone}</strong> within 24 hours to discuss the <strong>{plan.title}</strong>.
            </p>
            <button onClick={onClose} style={{
              width:"100%", padding:"12px", borderRadius:12, border:"none",
              background:"#1F4E8C", color:"#fff", fontWeight:800,
              fontSize:14, cursor:"pointer", fontFamily:"inherit"
            }}>Done ✓</button>
          </div>
        ) : (
          <>
            {/* Header */}
            <div style={{ marginBottom:20 }}>
              <div style={{
                display:"inline-flex", alignItems:"center", gap:8,
                background:`rgba(31,78,140,.09)`, border:`1px solid rgba(31,78,140,.20)`,
                borderRadius:10, padding:"5px 12px", marginBottom:12
              }}>
                <span style={{ fontSize:16 }}>{TAB_ICONS[plan.key]}</span>
                <span style={{ fontSize:12, fontWeight:700, color:"#1F4E8C" }}>{plan.title}</span>
              </div>
              <h3 style={{ margin:"0 0 4px", fontSize:20, fontWeight:800, color:"#1E293B" }}>
                Request a Callback
              </h3>
              <p style={{ margin:0, fontSize:13, color:"#64748B" }}>
                Our care advisor will call you within 24 hours
              </p>
            </div>

            {/* Price highlight */}
            <div style={{
              background:`${"#1F4E8C"}10`, border:`1px solid rgba(31,78,140,.16)`,
              borderRadius:12, padding:"12px 16px", marginBottom:20,
              display:"flex", justifyContent:"space-between", alignItems:"center"
            }}>
              <span style={{ fontSize:13, color:"#64748B", fontWeight:600 }}>Monthly Price</span>
              <span style={{ fontSize:22, fontWeight:900, color:"#1F4E8C" }}>{plan.price}<span style={{ fontSize:13, fontWeight:600 }}>/month</span></span>
            </div>

            <form onSubmit={submit}>
              {[
                { key:"name",  label:"Full Name *",     placeholder:"Your full name",       type:"text" },
                { key:"phone", label:"Phone Number *",  placeholder:"10-digit phone number", type:"tel" },
                { key:"time",  label:"Preferred Time",  placeholder:"e.g. Morning, Afternoon, Evening", type:"text" },
              ].map(f => (
                <div key={f.key} style={{ marginBottom:14 }}>
                  <label style={{ fontSize:12, fontWeight:700, color:"#374151", display:"block", marginBottom:5 }}>{f.label}</label>
                  <input
                    type={f.type} value={form[f.key]} placeholder={f.placeholder}
                    onChange={e => setForm(p=>({...p,[f.key]:e.target.value}))}
                    maxLength={f.key==="phone"?10:undefined}
                    style={{
                      width:"100%", padding:"11px 13px", borderRadius:10,
                      border:"1.5px solid #E2E8F0", fontSize:14, outline:"none",
                      fontFamily:"inherit", boxSizing:"border-box"
                    }}
                  />
                </div>
              ))}
              <button type="submit" disabled={loading || !form.name || !form.phone} style={{
                width:"100%", padding:"13px", borderRadius:12, border:"none",
                background: (!form.name||!form.phone) ? "#CBD5E1" : "#1F4E8C",
                color:"#fff", fontWeight:800, fontSize:15,
                cursor: (!form.name||!form.phone) ? "not-allowed" : "pointer",
                fontFamily:"inherit", marginTop:4
              }}>
                {loading ? "Sending..." : "📞 Request Callback"}
              </button>
            </form>
          </>
        )}
      </div>
    </>
  );
}

// ── Addon Section ─────────────────────────────────────────
function AddonSection({ activeTab, setActiveTab, sections, handleTabClick }) {
  const [callbackPlan, setCallbackPlan] = useState(null);
  const activePlan = ADDON_PLANS.find(p => p.key === activeTab) || ADDON_PLANS[0];

  return (
    <div style={{ maxWidth:1200, margin:"0 auto", padding:"60px 16px 80px" }}>

      {/* Section heading */}
      <div style={{ textAlign:"center", marginBottom:36 }}>
        <div style={{ fontSize:12, fontWeight:800, color:"#1F4E8C", textTransform:"uppercase", letterSpacing:".6px", marginBottom:8 }}>
          Specialised Care Add-ons
        </div>
        <h2 style={{ fontFamily:"inherit", fontSize:"clamp(22px,4vw,34px)", fontWeight:800, color:"#1E293B", margin:"0 0 10px" }}>
          Disease Management Plans
        </h2>
        <p style={{ color:"#64748B", fontSize:15, maxWidth:560, margin:"0 auto" }}>
          Targeted care programs for chronic conditions — designed by senior care specialists
        </p>
      </div>

      {/* Tab buttons — horizontally scrollable on mobile */}
      <div style={{ overflowX:"auto", scrollbarWidth:"none", marginBottom:28 }}>
        <div style={{ display:"flex", gap:8, minWidth:"max-content", padding:"4px 0 10px" }}>
          {ADDON_PLANS.map(p => {
            const isActive = activeTab === p.key;
            return (
              <button key={p.key} onClick={() => handleTabClick(p.key)} style={{
                display:"flex", alignItems:"center", gap:7,
                padding:"10px 18px", borderRadius:24, border:"1.5px solid",
                borderColor: isActive ? "#1F4E8C" : "#E2E8F0",
                background:  isActive ? "#1F4E8C" : "#fff",
                color:       isActive ? "#fff"    : "#475569",
                fontWeight:  700, fontSize:13, cursor:"pointer",
                fontFamily:"inherit", whiteSpace:"nowrap",
                boxShadow: isActive ? "0 4px 14px rgba(31,78,140,.35)" : "none",
                transition:"all .2s"
              }}>
                <span style={{ fontSize:16 }}>{TAB_ICONS[p.key]}</span>
                {TAB_LABELS[p.key]}
              </button>
            );
          })}
        </div>
      </div>

      {/* Active plan card */}
      {ADDON_PLANS.map(plan => (
        <div key={plan.key} ref={sections[plan.key]}
          style={{ display: activeTab === plan.key ? "block" : "none" }}>
          <div style={{
            background:"#fff", borderRadius:20,
            border:`1.5px solid rgba(31,78,140,.20)`,
            boxShadow:`0 8px 32px rgba(31,78,140,.09)`,
            overflow:"hidden"
          }}>
            {/* Card header bar */}
            <div style={{ height:6, background:`linear-gradient(90deg, ${"#1F4E8C"}, #4a7dc4)` }}/>

            <div style={{ padding:"28px 28px 24px" }}>
              {/* Title row */}
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:16, marginBottom:24 }}>
                <div>
                  <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
                    <span style={{
                      width:40, height:40, borderRadius:12,
                      background:`rgba(31,78,140,.09)`, display:"flex",
                      alignItems:"center", justifyContent:"center", fontSize:20
                    }}>{TAB_ICONS[plan.key]}</span>
                    <h2 style={{ fontFamily:"inherit", fontSize:"clamp(18px,3vw,26px)", fontWeight:800, color:"#1E293B", margin:0 }}>
                      {plan.title}
                    </h2>
                  </div>
                  <p style={{ color:"#64748B", fontSize:14, margin:0 }}>
                    Monthly specialised care programme — cancel anytime
                  </p>
                </div>
                {/* Price + button — desktop only, moves below on mobile */}
                <div className="addon-price-block" style={{ textAlign:"center", flexShrink:0 }}>
                  <div style={{ fontSize:36, fontWeight:900, color:"#1F4E8C", lineHeight:1 }}>
                    {plan.price}
                  </div>
                  <div style={{ fontSize:13, color:"#94A3B8", marginBottom:14 }}>/month*</div>
                  <button onClick={() => setCallbackPlan(plan)} style={{
                    padding:"12px 28px", borderRadius:12, border:"none",
                    background:"#1F4E8C", color:"#fff",
                    fontWeight:800, fontSize:14, cursor:"pointer",
                    fontFamily:"inherit", whiteSpace:"nowrap",
                    boxShadow:`0 4px 14px rgba(31,78,140,.25)`
                  }}>
                    📞 Request Callback
                  </button>
                </div>
              </div>

              {/* Divider */}
              <div style={{ height:1, background:"#F1F5F9", marginBottom:20 }}/>

              {/* Features grid */}
              <div style={{
                display:"grid",
                gridTemplateColumns:"repeat(auto-fill, minmax(240px, 1fr))",
                gap:12, marginBottom:24
              }}>
                {plan.items.map((item, i) => (
                  <div key={i} style={{
                    display:"flex", alignItems:"flex-start", gap:10,
                    padding:"12px 14px", borderRadius:12,
                    background:"#F8FAFC", border:"1px solid #F1F5F9"
                  }}>
                    <span style={{
                      width:22, height:22, borderRadius:"50%", flexShrink:0,
                      background:`rgba(31,78,140,.09)`, color:"#1F4E8C",
                      display:"flex", alignItems:"center", justifyContent:"center",
                      fontSize:12, fontWeight:900, marginTop:1
                    }}>✓</span>
                    <span style={{ fontSize:13, color:"#374151", fontWeight:600, lineHeight:1.5 }}>{item}</span>
                  </div>
                ))}
              </div>

              {/* Mobile price + button */}
              <div className="addon-price-mobile" style={{
                background:`rgba(31,78,140,.05)`, border:`1px solid rgba(31,78,140,.13)`,
                borderRadius:14, padding:"18px", textAlign:"center"
              }}>
                <div style={{ fontSize:32, fontWeight:900, color:"#1F4E8C" }}>{plan.price}</div>
                <div style={{ fontSize:13, color:"#94A3B8", marginBottom:14 }}>/month*</div>
                <button onClick={() => setCallbackPlan(plan)} style={{
                  width:"100%", padding:"13px", borderRadius:12, border:"none",
                  background:"#1F4E8C", color:"#fff",
                  fontWeight:800, fontSize:15, cursor:"pointer", fontFamily:"inherit"
                }}>
                  📞 Request Callback
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Callback popup */}
      {callbackPlan && (
        <CallbackPopup plan={callbackPlan} onClose={() => setCallbackPlan(null)} />
      )}

      <style>{`
        .addon-price-block { display: block; }
        .addon-price-mobile { display: none; }
        @media (max-width: 640px) {
          .addon-price-block { display: none; }
          .addon-price-mobile { display: block; }
        }
      `}</style>
    </div>
  );
}

// ────────────────────────────────────────────────────────
const Plans = () => {
  const [billing,      setBilling]     = useState("monthly");
  const [popupData,    setPopupData]   = useState(null);
  const [confirmPlan,  setConfirmPlan] = useState(null);
  const [successData,  setSuccessData] = useState(null);
  const [paying,       setPaying]      = useState(false);
  const [myActiveSub,  setMyActiveSub] = useState(null);
  const [activeTab,    setActiveTab]   = useState("care");
  const [selectedPlan, setSelectedPlan] = useState(null); // index of clicked/selected card
  const [backendPlans, setBackendPlans] = useState([]); // plans from DB
  const navigate = useNavigate();

  const sections = {
    care:     useRef(null),
    diabetes: useRef(null),
    dementia: useRef(null),
    kidney:   useRef(null),
    stroke:   useRef(null),
  };

  // Fetch plans from backend + user's active subscription
  useEffect(() => {
    // Always fetch plans (public endpoint)
    fetch(`${BASE_URL}/api/subscriptions/plans`)
      .then(r => r.json().then(data => ({ ok: r.ok, status: r.status, data })))
      .then(({ ok, status, data }) => {
        if (data.plans) { setBackendPlans(data.plans); return; }
        console.error(`Plans fetch failed — status ${status}:`, data.message, data.error);
      })
      .catch(err => console.error("Plans fetch network error:", err.message));

    // Fetch active subscription if logged in
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch(`${BASE_URL}/api/subscriptions/my`, { headers: authHeaders() })
      .then(r => r.json())
      .then(data => { if (data.active) setMyActiveSub(data.active); })
      .catch(() => {});
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sections[tab]?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  // ── Subscribe button handler ─────────────────────────
  const handleSubscribe = (plan) => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login", { state: { from: "/plans" } });
      return;
    }

    if (myActiveSub) {
      alert(`You already have an active "${myActiveSub.plan_name}" subscription valid until ${new Date(myActiveSub.end_date).toLocaleDateString("en-IN")}.`);
      return;
    }

    // Extract numeric price from plan.pricing (e.g. "₹999" → 999)
    const rawPrice = plan.pricing[billing].replace(/[₹,\s]/g, "");
    const planPrice = parseFloat(rawPrice);

    // Match against backend plans by price — this MUST match exactly.
    // We intentionally do NOT fall back to a guessed plan_id here: with 5
    // plans × 3 billing cycles, guessing wrong could charge the wrong plan
    // or amount. If the backend doesn't have a matching row yet (e.g. a
    // new quarterly plan that hasn't been added to subscription_plans),
    // fail safely and tell the person to contact support instead.
    const matched = backendPlans.find(bp => Math.abs(parseFloat(bp.price) - planPrice) < 1);

    if (!matched) {
      alert(
        `This plan (${plan.title} — ${billing}) isn't set up for online payment yet. ` +
        `Please contact support to subscribe, or try a different billing option.`
      );
      return;
    }

    setConfirmPlan({
      title:   plan.title,
      price:   matched.price,
      plan_id: matched.id,
      billing,
    });
  };

  // ── Payment flow ──────────────────────────────────────
  const handlePay = async () => {
    if (!confirmPlan) return;
    setPaying(true);

    try {
      const loaded = await loadRazorpayScript();
      if (!loaded) {
        alert("Failed to load payment gateway. Please check your internet.");
        setPaying(false);
        return;
      }

      // 1. Create order on backend
      const res = await fetch(`${BASE_URL}/api/subscriptions/create-order`, {
        method:  "POST",
        headers: authHeaders(),
        body:    JSON.stringify({ plan_id: confirmPlan.plan_id, billing_cycle: confirmPlan.billing }),
      });
      const orderData = await res.json();
      if (!res.ok) throw new Error(
        (orderData.message || "Order creation failed") +
        (orderData.error ? ` — ${orderData.error}` : "")
      );

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      // 2. Open Razorpay checkout
      const rzp = new window.Razorpay({
        key:         orderData.razorpay_key,
        amount:      orderData.amount,
        currency:    orderData.currency,
        name:        "Suvidha Elder Care",
        description: `${confirmPlan.title} — ${confirmPlan.billing}`,
        order_id:    orderData.razorpay_order_id,
        prefill: {
          name:    user.full_name || "",
          contact: user.phone    || "",
          email:   user.email    || "",
        },
        theme: { color: "#1F4E8C" },
        modal: {
          ondismiss: () => setPaying(false),
        },
        handler: async (response) => {
          // 3. Verify payment → instant activation
          try {
            const verifyRes = await fetch(`${BASE_URL}/api/subscriptions/verify-payment`, {
              method:  "POST",
              headers: authHeaders(),
              body:    JSON.stringify({
                razorpay_order_id:   response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature:  response.razorpay_signature,
                subscription_id:     orderData.subscription_id,
              }),
            });
            const verifyData = await verifyRes.json();
            if (!verifyRes.ok) throw new Error(verifyData.message);

            // Show success
            setConfirmPlan(null);
            setPaying(false);
            setMyActiveSub(verifyData.subscription);
            setSuccessData({
              plan_name: verifyData.subscription.plan_name,
              end_date:  verifyData.subscription.end_date,
            });
          } catch (err) {
            alert("Payment verified but activation failed: " + err.message);
            setPaying(false);
          }
        },
      });

      rzp.open();
    } catch (err) {
      alert(err.message || "Payment failed");
      setPaying(false);
    }
  };

  return (
    <>
      <Header />
      <div className="plans-wrapper">

        {/* ── Active Subscription Banner ─────────────── */}
        {myActiveSub && (
          <div className="pp-active-banner">
            <span>✅ You have an active <strong>{myActiveSub.plan_name}</strong> subscription</span>
            <span className="pp-active-until">
              Valid until {new Date(myActiveSub.end_date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}
            </span>
            <button onClick={() => navigate("/my-subscription")} className="pp-view-sub-btn">
              View Details →
            </button>
          </div>
        )}

        {/* HERO */}
        <div
          className="plans-hero"
          role="img"
          aria-label="Plans that fit their needs. Choose the right care plan for your loved ones. From everyday support to comprehensive elder care, explore plans designed to keep your parents safe, comfortable, and well cared for."
        >
          {/* Desktop / tablet — full designed banner, text baked into the image */}
          <div className="plans-hero-full" />

          {/* Mobile — same image split into a legible text crop stacked
              above a photo crop, same technique as the Contact page hero. */}
          <div className="plans-hero-mobile">
            <div className="phm-text" />
            <div className="phm-photo" />
          </div>
        </div>

        {/* TOGGLE */}
        <div className="billing-toggle">
          <button className={billing === "monthly" ? "active" : ""} onClick={() => setBilling("monthly")}>
            Monthly
          </button>
          <button className={billing === "quarterly" ? "active" : ""} onClick={() => setBilling("quarterly")}>
            Quarterly
          </button>
          <button className={billing === "yearly" ? "active" : ""} onClick={() => setBilling("yearly")}>
            Yearly <span className="pp-save-badge">Save 30%</span>
          </button>
        </div>

        {/* CARDS */}
        <div className="plans-container">
          {plans.map((plan, index) => {
            const features  = plan.features[billing];
            const firstSeven = features.slice(0, 7);
            const isActive  = myActiveSub && plan.title.toLowerCase().includes(
              (myActiveSub.plan_name || "").split(" ")[0].toLowerCase()
            );

            return (
              <div
                key={index}
                className={`plan-card ${plan.highlight ? "highlight" : ""} ${selectedPlan === index ? "selected" : ""}`}
                onClick={() => setSelectedPlan(index)}
              >
                {isActive && <div className="pp-active-tag">✅ Current Plan</div>}
                {!isActive && selectedPlan === index && (
                  <div className="pp-selected-tag">✓ Selected</div>
                )}
                <h2 className="plan-title">{plan.title}</h2>
                <p className="plan-text">{plan.text}</p>
                <h2 className="price">
                  {plan.pricing[billing]}
                  <span>/{billing === "monthly" ? "month" : billing === "quarterly" ? "quarter" : "year"}</span>
                </h2>
                <div className="card-divider"></div>
                <ul>
                  {firstSeven.map((item, i) => <li key={i}>✓ {item}</li>)}
                </ul>
                {features.length > 7 && (
                  <p className="read-more" onClick={(e) => { e.stopPropagation(); setPopupData(plan); }}>Read more</p>
                )}
                <button
                  className={`connect-btn ${isActive ? "connect-btn-active" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedPlan(index);
                    isActive ? navigate("/my-subscription") : handleSubscribe(plan);
                  }}
                >
                  {isActive ? "✅ Manage Plan" : "Subscribe Now"}
                </button>
              </div>
            );
          })}
        </div>

        {/* POPUP MODAL */}
        {popupData && (
          <div className="popup-overlay" onClick={() => setPopupData(null)}>
            <div className="popup-card highlight" onClick={e => e.stopPropagation()}>
              <div className="popup-close" onClick={() => setPopupData(null)}>✕</div>
              <h3>{popupData.title}</h3>
              <p className="plan-text">{popupData.text}</p>
              <div className="card-divider"></div>
              <div className="popup-features">
                <ul>
                  {popupData.features[billing].map((item, i) => <li key={i}>✓ {item}</li>)}
                </ul>
              </div>
              <button className="connect-btn popup-btn" onClick={() => { setPopupData(null); handleSubscribe(popupData); }}>
                Subscribe Now
              </button>
            </div>
          </div>
        )}
      </div>

      {/* PREMIUM BENEFITS — Responsive Grid replacing broken carousel */}
      <PremiumBenefits
        images={[image4,image5,image6,image7,image8,image9,image10]}
      />

      {/* ADD-ONS SECTION */}
      <AddonSection activeTab={activeTab} setActiveTab={setActiveTab} sections={sections} handleTabClick={handleTabClick} />

      <TestimonialSlider />
      <Footer />

      {/* ── Confirm Payment Modal ── */}
      {confirmPlan && !successData && (
        <ConfirmModal
          plan={confirmPlan.title}
          billing={confirmPlan.billing}
          price={confirmPlan.price}
          onConfirm={handlePay}
          onClose={() => { if (!paying) setConfirmPlan(null); }}
          loading={paying}
        />
      )}

      {/* ── Success Modal ── */}
      {successData && (
        <SuccessModal
          plan={successData.plan_name}
          endDate={successData.end_date}
          onClose={() => { setSuccessData(null); navigate("/my-subscription"); }}
        />
      )}
    </>
  );
};

export default Plans;